import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Dashboard from "../../layouts/Dashboard";
import * as Yup from "yup";
import Axios from "axios";
import url from "../../services/url";
import { useHistory, useParams, Link } from "react-router-dom";
import saveLog from "../../services/saveLog";
import { Card, Tooltip, Typography } from "antd";
import axios from "../../services/axios";
import moment from "moment";
import ReactLoading from "react-loading";
import isConsultant from "../../services/isConsultant";
import BASE from "../../config";
import {
  RetweetOutlined,
  SearchOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Input, Tag } from "antd";
import { useLocation } from "react-router-dom";
import useAxios from "../../hooks/useAxios";
import useSearchContext from "../../hooks/useSearchContext";
const { Title, Text } = Typography;

function formatDate(d) {
  let date = new Date(d);
  let dd = date.getDate();
  let mm = date.getMonth() + 1;
  let yyyy = date.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return (d = dd + "/" + mm + "/" + yyyy);
}

const TABS = [
  {
    label: "Total Vacancy (Active + Inactive)",
    key: "total_vacancy",
    url: ``,
  },
  {
    label: "New Application",
    key: "new",
    url: `/candidate_dashboard?tab=Application_Received`,
    tabType: "Application_Received",
  },
  {
    label: "In Process",
    key: "in_process",
    url: `/candidate_dashboard?tab=Application_Received`,
    tabType: "In_Process",
  },
  {
    label: "On Hold",
    key: "on_hold",
    url: `/candidate_dashboard?tab=On Hold`,
    tabType: "On Hold",
  },
  {
    label: "Rejected",
    key: "rejected",
    url: `/candidate_dashboard?tab=Rejected`,
    tabType: "Rejected",
  },
  {
    label: "Talent Pool",
    key: "talent_pool",
    url: `/candidate_dashboard?tab=TalentPool`,
    tabType: "TalentPool",
  },
  {
    label: "Hired",
    key: "hired",
    url: `/candidate_dashboard?tab=Hired`,
    tabType: "Hired",
  },
  {
    label: "Inactive Users",
    key: "inactive_users",
    url: "",
  },
];

const isValidParam = (value) =>
  value !== null && value !== "undefined" && value !== "";

function TalentRequisitionFormView() {
  // const [form, handleChange, getValue] = useForm();
  const startDate = moment().format("YYYY-MM-DD");
  const endDate = moment().subtract(12, "month").format("YYYY-MM-DD");
  const [values, setValues] = useState({});
  const [count, setCount] = useState({});
  const [tabCount, setTabCount] = useState({
    new: 0,
    in_process: 0,
    on_hold: 0,
    rejected: 0,
    talent_pool: 0,
    hired: 0,
  });
  const [competencies, setCompetencies] = useState([]);
  const [load, setLoad] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");
  const designationId = searchParams.get("designationId");
  const departmentId = searchParams.get("departmentId");
  const history = useHistory();
  const { id } = useParams();
  const api = useAxios();
  const {
    setTrfId,
    setHeaderFilterStatus,
    setAdvanceappliedFilters,
    location: locationFilter,
    setVersantScore,
    setLocation,
    setNormalFilters,
    setPositions,
    setFormId,
    setQualification,
    setInterviewStatus,
    setSource,
    setRecruiter,
    setCallMasterId,
    setSelectedDatevalue,
    setModeOfInterview,
    setInterested,
    setRotationalShift,
    setCurrent,
    setDefaultDate,
    setTsNavigateFromTrf,
    setCandidateType,
    setDepartmentId,
    setDesignationId,
    setWhatsAppCampaign,
    setWhatsAppResponse,
    setHirePage,
    setHoldPage,
    setRejectPage,
    setPoolPage,
  } = useSearchContext();

  const onSubmit = (values) => {
    Axios.put(url("/trf/" + id + "/edit"), values, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((result) => {
        alert("Form was saved successfully.");
      })
      .catch(alert);
    history.push("/trf/" + id + "/edit");
  };

  // useEffect(() => {
  //   Axios.get(url("/trf/" + id), {
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("user.token")}`,
  //     },
  //   })
  //     .then((res) => {
  //       setValues((prevValues) => {
  //         let trfRaisedDate = new Date(res.data.trfRaisedDate);
  //         let trfRaisedDateMonthPrependage = "";
  //         if (trfRaisedDate.getMonth() < 10) {
  //           trfRaisedDateMonthPrependage = "0";
  //         }
  //         let trfRaisedDateString =
  //           trfRaisedDate.getFullYear() +
  //           "-" +
  //           trfRaisedDateMonthPrependage +
  //           (trfRaisedDate.getMonth() + 1) +
  //           "-" +
  //           trfRaisedDate.getDate();

  //         let newValues = {
  //           position: res.data.position,
  //           vacancy: res.data.vacancy,
  //           trfRaisedDate: trfRaisedDateString,
  //           grade: res.data.grade,
  //           title: res.data.title,
  //           department: res.data.department,
  //           location: res.data.location,
  //           reportsTo: res.data.reportsTo,
  //           supervises: res.data.supervises,
  //           travel: res.data.travel,
  //           travelLocation: res.data.travelLocation,
  //           travelDays: res.data.travelDays,
  //           salary: res.data.salary,
  //           numberOfVacancies: res.data.numberOfVacancies,
  //           minimumAge: res.data.minimumAge,
  //           maximumAge: res.data.maximumAge,
  //           gender: res.data.gender,
  //           experienceRequired: res.data.experienceRequired,
  //           desiredQualification: res.data.desiredQualification,
  //           targetIndustry: res.data.targetIndustry,
  //           targetOrganization: res.data.targetOrganization,
  //           careerPathPotential: res.data.careerPathPotential,
  //           topPerformer: res.data.topPerformer,
  //           promotionable: res.data.promotionable,
  //           promotionableReason: res.data.promotionableReason,
  //           overview: res.data.overview,
  //           rolesAndResponsibilities: res.data.rolesAndResponsibilities,
  //           desiredCandidateProfile: res.data.desiredCandidateProfile,
  //           competencies: res.data.competencies,
  //           skills: res.data.skills,
  //         };
  //         return newValues;
  //       });
  //     })
  //     .catch(console.error);
  // }, [id]);

  const getTrf = async () => {
    try {
      const { data } = await api.get(`/trf/${id}`, {
        tokenType: "user",
      });
      setValues(data?.result);
    } catch (err) {
      console.error(err);
    }
  };
  const getTrfDetails = async () => {
    try {
      const { data } = await api.get(`/trf/TRfDetails/${id}`, {
        tokenType: "user",
      });
      setCount(data);
      return data;
    } catch (err) {
      console.error(err);
    }
  };
  const getCompetencies = async () => {
    try {
      const { data } = await api.get(
        `/competencyInterviewSetUp/designationId/${designationId}/departmentId/${departmentId}`,
        {
          tokenType: "user",
        },
      );
      console.log(data);
      setCompetencies(data);
      return data;
    } catch (err) {
      console.error(err);
    }
  };

  // const getCountDetails = async (type) => {
  //   try {
  //     const { data } = await api.get(
  //       `/candidates/Pagination?FormId=&PageSize=10&PageNo=1&Search=&Position=[]&ProcessId=&Status=${
  //         type !== "Application_Received" ? type : ""
  //       }&StartDate=&EndDate=&ScoreType=&InterviewType=${
  //         type === "Application_Received" ? "Application_Received" : ""
  //       }&Source=[]&Recruiter=[]&CandidateRole=[]&TRF=${id}&TabType=${type}&Designation=&Qualification=[]&jobType=[]&candidateType=[]&Versant=[]&CallStatus=&contactDelay=&modeofInterview=&Interested=[]&RotationalShift=[]&RequestType=%22App%22`,
  //       {
  //         tokenType: "user",
  //       }
  //     );
  //     const { candidateCount } = data || {};
  //     return candidateCount || 0;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const getNewCount = async () => {
  //   try {
  //     const candidateCount = await getCountDetails("Application_Received");
  //     return candidateCount;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const getInProcess = async () => {
  //   try {
  //     const candidateCount = await getCountDetails("In_Process");
  //     return candidateCount;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const getOnHold = async () => {
  //   try {
  //     const candidateCount = await getCountDetails("On Hold");
  //     return candidateCount;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const getRejected = async () => {
  //   try {
  //     const candidateCount = await getCountDetails("Rejected");
  //     return candidateCount;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const getTalentPool = async () => {
  //   try {
  //     const candidateCount = await getCountDetails("TalentPool");
  //     return candidateCount;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const getHired = async () => {
  //   try {
  //     const candidateCount = await getCountDetails("Hired");
  //     return candidateCount;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  useEffect(() => {
    if (!id) return;

    const init = async () => {
      try {
        setLoad(true);
        const promise = [
          // getNewCount(),
          // getInProcess(),
          // getOnHold(),
          // getRejected(),
          // getTalentPool(),
          // getHired(),
          getTrfDetails(),
          getTrf(),
        ];
        if (
          type === "Non-Agent" &&
          isValidParam(departmentId) &&
          isValidParam(departmentId)
        ) {
          promise.push(getCompetencies());
        }
        const [
          // newCount,
          // inProcessCount,
          // onHoldCount,
          // rejectedCount,
          // talentPoolCount,
          // hiredCount,
          trfDetails,
        ] = await Promise.all(promise);

        setTabCount({
          new: trfDetails?.newApplication || 0,
          in_process: trfDetails?.inProcess || 0,
          on_hold: trfDetails?.onHold || 0,
          rejected: trfDetails?.rejected || 0,
          talent_pool: trfDetails?.talentPool || 0,
          hired: trfDetails?.joined || 0,
        });
      } catch (err) {
        console.error(err);
      } finally {
        setLoad(false);
      }
    };

    init();
    // getLinkedUserWithTrf();
  }, [id]);

  // const [assignedUser, setAssignedUser] = useState([]);

  // const getLinkedUserWithTrf = async () => {
  //   const config = {
  //     url: `${BASE.api}/trfBasedUserMapping/${id}`,
  //     method: "get",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${localStorage.getItem("user.token")}`
  //     }
  //   };

  //   const result = await Axios(config);
  //   const data = result.data.trfList;
  //   let arr = [];
  //   for (let i = 0; i < data.length; i++) {
  //     arr.push({
  //       _id: data[i]._id,
  //       email: data[i].userId.email,
  //       name: data[i].userId.name,
  //       role: data[i].userId.role,
  //       completed: data[i].completedVacancy,
  //       pending: data[i].numberOfVacancies - data[i].completedVacancy,
  //       total: data[i].numberOfVacancies
  //     });
  //   }
  //   setAssignedUser(arr);
  // };

  const onClickView = (status) => {
    const activeFilters = 1;

    setAdvanceappliedFilters(activeFilters);
    setTrfId(id);
    setHeaderFilterStatus(status?.tabType);
    setSelectedDatevalue("Custom");
    setDefaultDate([]);
    setTsNavigateFromTrf(true);
    setVersantScore([]);
    setLocation([]);
    setNormalFilters(0);
    setPositions([]);
    setFormId("");
    setQualification([]);
    setInterviewStatus("");
    setSource([]);
    setRecruiter([]);
    setCallMasterId("");
    setModeOfInterview("");
    setInterested([]);
    setRotationalShift([]);
    setCandidateType([]);
    setDepartmentId([]);
    setDesignationId([]);
    setWhatsAppCampaign("");
    setWhatsAppResponse("");
    setCurrent(1);
    setHirePage(1);
    setHoldPage(1);
    setRejectPage(1);
    setPoolPage(1);
    history.push(status?.url);
  };

  const APPROVALS = values?.approvals ? values?.approvals : [];

  return (
    <div>
      {!isConsultant() && (
        <div>
          {load && (
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          )}
          <Dashboard title="Talent Requisition Form Edit">
            <div className="talent">
              <h4 class="mb-4">
                {values?.title}-{values?.department}-{values?.location}-
                {values?.processName}-({values?.candidateType})
              </h4>
              <div className="bg-white p-4">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(auto-fit, minmax(215px, 1fr))`,
                    gap: "1rem",
                  }}
                  className="mb-4"
                >
                  {TABS.map((status) => (
                    <div
                      style={{
                        width: "100%",
                      }}
                      key={status.label}
                      onClick={() => {
                        if (status?.url) {
                          onClickView(status);
                        }
                      }}
                    >
                      <Card
                        bordered
                        style={{
                          borderColor: "#7D7C7C",
                          padding: "7px",
                          height: "80px",
                          borderRadius: "6px",
                          cursor: status?.url ? "pointer" : "",
                          background: "#fff",
                        }}
                        bodyStyle={{ padding: 8 }}
                      >
                        <div className="d-flex gap-1 align-items-center">
                          <Text
                            style={{
                              fontSize: 12,
                              fontWeight: 600,
                              textDecoration: "none",
                            }}
                          >
                            {status.label}
                          </Text>
                          {/* <Tooltip placement="top" title={status.info}>
                            <InfoCircleOutlined
                              style={{
                                color: "black",
                                fontSize: "1.1rem",
                              }}
                            />
                          </Tooltip> */}
                        </div>
                        <div
                          style={{
                            fontSize: 16,
                            fontWeight: "bold",
                            textDecoration: status?.url ? "underline" : "",
                            color: status?.url ? "#669DF1" : "",
                          }}
                        >
                          {status?.key === "total_vacancy" ||
                          status?.key === "inactive_users" ? (
                            <>
                              {status?.key === "total_vacancy" ? (
                                <>
                                  {Number(values?.numberOfVacancies || 0) +
                                    Number(
                                      values?.bufferVacancyCount || 0,
                                    )}{" "}
                                  (
                                  {(count?.joined || 0) +
                                    (count?.inactiveJoinedcandidate || 0)}{" "}
                                  Closed)
                                </>
                              ) : (
                                <>{count?.inactiveJoinedcandidate || 0}</>
                              )}
                            </>
                          ) : (
                            <>{tabCount[status?.key]}</>
                          )}
                        </div>
                      </Card>
                    </div>
                  ))}
                </div>
                {/* <div className="row">
                  <div className="col-12">
                    <Card title="Recruiters List" className="border mt-3">
                      <div style={{ width: "100%" }}>
                        <Table
                          columns={columns}
                          dataSource={assignedUser}
                          pagination={{
                            // total:count,
                            // pageSizeOptions: ["5", "10", "30", "60", "100", "1000"],
                            showSizeChanger: false
                          }}
                          scroll={{ x: true }}
                          style={{ whiteSpace: "pre" }}
                          exportFileName="details"
                        />
                      </div>
                    </Card>
                  </div>
                </div> */}
                <div className="row mt-4">
                  {/* <div className="col-md-6">
                    <Card
                      style={{ height: "-webkit-fill-available" }}
                      className="border"
                      title={"New Applicant" + " " + count?.newApplication}
                      // extra={<a href="/candidates">View all</a>}
                      extra={
                        <button onClick={showAllCandidate}>View all</button>
                      }
                      // extra={<Link
                      //   to={{
                      //     pathname: "/candidates",
                      //     state: {
                      //       a: "",
                      //       b: id,
                      //       c: values.title,
                      //       recStatus: false,
                      //     },
                      //   }}
                      // >
                      //   <button
                      //     onClick={() => {
                      //       localStorage.setItem("selectInterviewRound", "")
                      //     }}
                      //     class="btn btn-sm btn-primary btn-table-control mx-1"
                      //   >
                      //     View
                      //   </button>
                      // </Link>}
                    >
                      {applicant?.candidates?.map((candidate) => {
                        return (
                          <li>
                            {candidate?.Name}-{candidate["Phone Number"]}
                          </li>
                        );
                      })}
                    </Card>
                  </div> */}
                  <div className="col-md-6">
                    <Card
                      style={{ height: "-webkit-fill-available" }}
                      className="border"
                      title="Job Descriptions"
                    >
                      <p>
                        <strong> Roles & Responsibilities</strong> -{" "}
                        {values?.rolesAndResponsibilities} <br />
                        <strong>Competencies</strong> - {values?.competencies}{" "}
                        <br />
                        <strong>Required Qualification</strong> -{" "}
                        {values?.desiredQualification} <br />
                        {/* {values?.overview} */}
                      </p>
                    </Card>
                  </div>
                  <div className="col-md-6">
                    <Card
                      style={{ height: "-webkit-fill-available" }}
                      className="border"
                      title="TRF Details"
                    >
                      <li>Raised By: {values?.raisedBy}</li>
                      <li>Department: {values?.department}</li>
                      <li>Location: {values?.location}</li>
                      <li>Priority: {values?.priority}</li>
                      <li>Salary: {values?.salary}/year</li>
                      <li>Job Type: Onsite - {values?.location}</li>
                      <li>TAT Date - {formatDate(values?.tat)}</li>
                      {/* <li>
                  Interview Process: 3 Phases
                  <li>1. Video Call: Puneet Mehra (60 mins)</li>
                  <li>
                    2. Practical Test: Coding Test <a href="#">Attached</a>
                  </li>
                  <li>3. In Person: Tarun Jain (30 mins)</li>
                </li> */}
                    </Card>
                  </div>
                </div>

                <div className="row mt-4">
                  {/* <div className="col-md-6 ">
                    <Card
                      style={{ height: "-webkit-fill-available" }}
                      className="border"
                      title="Interview Process"
                      extra={
                        <Link
                          to={"/candidate_dashboard?tab=Application_Received"}
                        >
                          <button
                            onClick={onClickView}
                            style={{
                              color: "black",
                              textDecoration: "underline",
                            }}
                          >
                            View
                          </button>
                        </Link>
                      }
                    >
                      <div>
                        <li>First Level: {count?.firstLevel}</li>
                        <li>Second Level: {count?.secondLevel}</li>
                        <li>Final Level: {count?.thirdLevel}</li>
                      </div>
                    </Card>
                  </div> */}
                  <div className="col-md-6">
                    <Card
                      style={{ height: "-webkit-fill-available" }}
                      className="border"
                      title="Approvals"
                    >
                      {APPROVALS?.map((trf) => {
                        return (
                          <p>
                            Level {trf?.levelNo} - {trf?.status} <br />
                            {trf?.status} By - {trf?.level} <br />
                          </p>
                        );
                      })}
                    </Card>
                  </div>
                  {type === "Non-Agent" && (
                    <div className="col-md-6">
                      <Card
                        style={{ height: "-webkit-fill-available" }}
                        className="border"
                        title="Competencies"
                      >
                        {competencies?.length === 0 ? (
                          <p>No competencies bind with this TRF.</p>
                        ) : (
                          <ul
                            style={{
                              listStyleType: "disc",
                              paddingLeft: "20px",
                            }}
                          >
                            {competencies?.map((comp) => {
                              const { competencyintervieweetupsData } =
                                comp || {};
                              return competencyintervieweetupsData?.map(
                                (subComp) => {
                                  const { competencyNamesData, maxQuestion } =
                                    subComp || {};
                                  const { competencyNames } =
                                    competencyNamesData?.[0];
                                  return <li>{competencyNames}</li>;
                                },
                              );
                            })}
                          </ul>
                        )}
                      </Card>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Dashboard>
        </div>
      )}
    </div>
  );
}

export default TalentRequisitionFormView;
